import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myPaymentsAndInvoicesRoute: RouteConfig<'with-page'> = {
    name: 'Payments & Invoices',
    path: '/myaccount/payments',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}